import { connect } from 'react-redux'
import { getCurrentColorScheme } from '@selectors/data/color_scheme_selectors.js'
import { selectors as selectableSelectors } from '@features/selectable/index.js'
import TimelineSwitcher from '@components/timelines/timeline_switcher.jsx'

const mapStateToProps = (state, props) => {
  const { namespace } = props
  const colorScheme = getCurrentColorScheme(state)
  const viewSize = selectableSelectors.getValue(state, { namespace, scope: 'viewSize' })
  const viewType = selectableSelectors.getValue(state, { namespace, scope: 'viewType' })
  const mappedProps = {
    viewType,
    viewSize,
    colorScheme,
  }
  return mappedProps
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TimelineSwitcher)
